/**
 * useEscapeKey Hook
 * Handles Escape key press to close modals
 */

import { useEffect } from 'react';

interface UseEscapeKeyOptions {
  enabled?: boolean;
  onEscape: () => void;
}

export function useEscapeKey({ enabled = true, onEscape }: UseEscapeKeyOptions) {
  useEffect(() => {
    if (!enabled) return;

    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onEscape();
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [enabled, onEscape]);
}
